<div class="p-dialog dialog card-container" style="max-width: 400px !important;">
  <button pButton type="button" icon="pi pi-times"
          [style]="{'margin-left':'310px', 'margin-top':'-20px'}"
          class="p-button-rounded p-button-text p-button-plain title-button"
          (click)="onClose()"></button>
  <div style="margin: 0 5% 20px" class="p-d-flex p-ai-center">
    <img
      id="profile-img"
      src="assets/user.png"
      class="profile-img-card p-d-none p-d-md-inline-flex" style="margin-right:20px;"
    />
    <span style="font-size:30px;">User Login</span>
  </div>

    <form
      name="form"
      (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm"
      novalidate
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
        </div>
        <div class="p-field p-col-12 p-md-6">
          <button pButton type="button" label="Forget password?"
                  [style]="{'text-align':'right'}"
                  class="p-button-text"
                  (click)="showConfirm()"></button>
        </div>
        <div class="p-field p-col-12 p-md-12">
          <span class="p-float-label">
            <input
              type="text"
              id="username"
              name="username"
              [(ngModel)]="form.username"
              required
              #username="ngModel"
              pInputText
            />
            <label for="username">Username</label>
          </span>
          <div class="alert" *ngIf="username.errors && f.submitted">
            Username is required!
          </div>
        </div>
        <div class="p-field p-col-12 p-md-12">
          <span class="p-float-label">
            <input
              type="password"
              id="password"
              name="password"
              [(ngModel)]="form.password"
              required
              minlength="6"
              #password="ngModel"
              pInputText
            />
            <label for="password">Password</label>
          </span>
          <div class="alert" *ngIf="password.errors && f.submitted">
            <div *ngIf="password.errors.required">Password is required</div>
            <div *ngIf="password.errors.minlength">
              Password must be at least 6 characters
            </div>
          </div>
        </div>
        <div class="p-field p-col-12 p-md-12">
          <Input class="button_black" Type="Submit" Value="Log In" style="width:100%; height:35px;" />
        </div>

        <div class="form-group" style="padding: 5px 10px">
          <div class="alert" *ngIf="f.submitted && isLoginFailed">
            Login failed: {{ errorMessage }}
          </div>
        </div>
      </div>
    </form>
  </div>

<img class="progress-spinner rotate" *ngIf="isBusy" src="assets/loading.png" alt="loading...">

<!-- Confirmation -->
<p-toast styleClass="p-toast-narrower" position="bottom-center" key="c" (onClose)="onReject()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center">
        <h4>Password Reset</h4>
        <p style="text-align: left">We will reset your password. Please confirm to proceed.</p>
      </div>
      <div class="p-grid p-fluid">
        <div class="p-col-6">
          <button type="button" pButton (click)="onConfirm()" label="Reset" class="p-button-success"></button>
        </div>
        <div class="p-col-6">
          <button type="button" pButton (click)="onReject()" label="Cancel" class="p-button-secondary"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
